import { useEffect, useRef } from 'react';

export const useDebounce = (
  effect: Function,
  delay: number,
  deps: Array<string | undefined>,
  skipInitialEffect?: boolean
): void => {
  const isFirstEffect = useRef(true);
  useEffect(() => {
    if (skipInitialEffect && isFirstEffect.current) {
      isFirstEffect.current = false;
      return;
    }
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
  }, [...deps, delay]);
};
